export class OAuthToken {
  accessToken: string
  refreshToken: string
  tokenType: string
  scope: string
  expiresIn: number
  timestamp: number

  constructor(data: any = {}) {
    this.accessToken = data.accessToken ? data.accessToken : data.access_token ? data.access_token : ''
    this.refreshToken = data.refreshToken ? data.refreshToken : data.refresh_token ? data.refresh_token : ''
    this.tokenType = data.tokenType ? data.tokenType : data.token_type ? data.token_type : ''
    this.scope = data.scope ? data.scope : ''
    this.expiresIn = data.expiresIn ? data.expiresIn : data.expires_in ? data.expires_in : 0
    this.timestamp = data.timestamp ? data.timestamp : +new Date()
  }
}
export class OAuthSession {
  clientId: string
  clientSecret: string
  clientType: string
  clientCustomUri: string
  email: string
  password: string
  isAuthenticated: boolean
  isRememberMe: boolean
  token: OAuthToken

  constructor(data: any = {}) {
    this.clientId = data.clientId ? data.clientId : ''
    this.clientSecret = data.clientSecret ? data.clientSecret : ''
    this.clientType = data.clientType ? data.clientType : 'prod'
    this.clientCustomUri = data.clientCustomUri ? data.clientCustomUri : ''
    this.email = data.email ? data.email : ''
    this.password = data.password ? data.password : ''
    this.isAuthenticated = data.isAuthenticated ? data.isAuthenticated : false
    this.isRememberMe = data.isRememberMe ? data.isRememberMe : false
    this.token = data.token ? new OAuthToken(data.token) : new OAuthToken()
  }
}
export const DEFAULT_CLIENT_KEYS = {
  prod: {
    clientId: '2_NXDodEF6OyKawRuHxCoNoyL6WcE1r5cDOxJohc7Sod6l01qP6D',
    clientSecret: 'FZMH4IrOuqQQSuJJE4I6D7VR088EB84S3I4nwmrSzjTeKXgyje',
  },
  'prod-hs': {
    clientId: '2_NXDodEF6OyKawRuHxCoNoyL6WcE1r5cDOxJohc7Sod6l01qP6D',
    clientSecret: 'FZMH4IrOuqQQSuJJE4I6D7VR088EB84S3I4nwmrSzjTeKXgyje',
  },
  stage: {
    clientId: '2_NXDodEF6OyKawRuHxCoNoyL6WcE1r5cDOxJohc7Sod6l01qP6D',
    clientSecret: 'FZMH4IrOuqQQSuJJE4I6D7VR088EB84S3I4nwmrSzjTeKXgyje',
  },
  'stage-hs': {
    clientId: '2_NXDodEF6OyKawRuHxCoNoyL6WcE1r5cDOxJohc7Sod6l01qP6D',
    clientSecret: 'FZMH4IrOuqQQSuJJE4I6D7VR088EB84S3I4nwmrSzjTeKXgyje',
  },
  dev: {
    clientId: '2_NXDodEF6OyKawRuHxCoNoyL6WcE1r5cDOxJohc7Sod6l01qP6D',
    clientSecret: 'FZMH4IrOuqQQSuJJE4I6D7VR088EB84S3I4nwmrSzjTeKXgyje',
  },
  custom: {
    clientId: '2_NXDodEF6OyKawRuHxCoNoyL6WcE1r5cDOxJohc7Sod6l01qP6D',
    clientSecret: 'FZMH4IrOuqQQSuJJE4I6D7VR088EB84S3I4nwmrSzjTeKXgyje',
  },
}

export const ENDPOINT = {
  GRAPHQL: 'graphql',
  GRAPHQL_POST: 'graphql_post',
  TOKEN: 'token',
  REFRESH_TOKEN: 'refresh_token',
}

type ServerSession = Pick<OAuthSession, 'clientType' | 'clientCustomUri'>

export const getServerUrl = (session: ServerSession): string => {
  let server = 'https://server1.depoto.cz/'

  if (session.clientType) {
    switch (session.clientType) {
      case 'prod':
        server = 'https://server1.depoto.cz/'
        break
      case 'prod-hs':
        server = 'https://api.evidentist.cz/'
        break
      case 'stage':
        server = 'https://server1.depoto.cz.tomatomstage.cz/'
        break
      case 'stage-hs':
        server = 'https://api.evidentist.cz.tomatomstage.cz/'
        break
      case 'dev':
        server = 'https://server-dev.depoto.cz/'
        break
      case 'custom':
        server = session.clientCustomUri?.endsWith('/') ? session.clientCustomUri : `${session.clientCustomUri}/`
        break
    }
  }

  return server
}

export const getEndpoint = (endpoint: string, session: OAuthSession) => {
  const server = getServerUrl(session)
  let route = ''
  const format = '.json'

  switch (endpoint) {
    case ENDPOINT.GRAPHQL:
      route = 'graphql?query='
      break
    case ENDPOINT.GRAPHQL_POST:
      route = 'graphql'
      break
    case ENDPOINT.TOKEN:
    case ENDPOINT.REFRESH_TOKEN:
      route = 'oauth/v2/token'
      break
  }

  if (endpoint === 'token' || endpoint === 'refresh_token' || endpoint === 'graphql' || endpoint === 'graphql_post') {
    return `${server}${route}`
  } else {
    return `${server}${route}${format}`
  }
}
